import * as React from "react";

import {
  Button as FluentButton,
  ButtonProps as FluentButtonProps,
} from "@fluentui/react-components";

export type ButtonVariant = "primary" | "secondary" | "outline-primary" | "outline-secondary";

export type CustomButtonProps = FluentButtonProps & {
  variant?: ButtonVariant;
  children?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  type?: "button" | "submit" | "reset";
  autoFocus?: boolean;
  form?: string;
  name?: string;
  value?: string;
};

const Button: React.FC<CustomButtonProps> = ({ variant = "primary", style, ...props }) => {
  // Map custom variants to Fluent UI appearances
  // Colors are now handled by the Fluent UI theme automatically
  const getAppearance = (): "primary" | "secondary" | "outline" | "subtle" | "transparent" => {
    switch (variant) {
      case "primary":
        return "primary";
      case "secondary":
        return "secondary";
      case "outline-primary":
      case "outline-secondary":
        return "outline";
      default:
        return "primary";
    }
  };

  return (
    <FluentButton
      appearance={getAppearance()}
      style={style}
      {...props}
    />
  );
};

export default Button;
